import React, { useEffect } from "react"
import { useRouter } from "next/router"
import LayoutSelect from "../../../../components/Layouts/LayoutSelect"

function Index() {
  const router = useRouter()

  useEffect(() => {
    router.push("/")
  }, [router.isReady])

  return (
    <React.Fragment>
      <LayoutSelect title="Перенаправление">
        <p className="text-center">Перенаправление...</p>
      </LayoutSelect>
    </React.Fragment>
  )
}

export default Index
